const deductionStyle = theme => ({
  container: {
    background: '#F0F5F2',
    border: "1px solid rgba(211, 67, 67, 0.55)"
  },
  subContainer: {
    background: '#fff',
    padding: '10px',
    borderRadius: '8px',
  },
  section: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '40px 10px'
  },
  text: {
    fontSize: '14px'
  },
})

export default deductionStyle;